import styled from "styled-components";
import {HeaderNavbarContainerDefaultBox} from "./header-navbar-container.default.box";

export const HeaderNavbarContainerSIBox = styled(HeaderNavbarContainerDefaultBox)`
  border-bottom: none;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    border-bottom: none;
  }
`;
